import React, { useState, useEffect } from 'react';
import MainLayout from '../../components/layouts/MainLayout';
import ProfileForm from '../../components/profile/ProfileForm';
import StoreSettingsForm from '../../components/profile/StoreSettingsForm';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { useAuth } from '../../hooks/useAuth';
import { useProfile } from '../../hooks/useProfile';
import { sellerService } from '../../services/seller.service';
import { useToast } from '../../components/common/Toast';
import { theme } from '../../config/theme';

const SellerProfile = () => {
  const { user } = useAuth();
  const { updateProfile, loading: profileLoading } = useProfile();
  const toast = useToast();
  const [seller, setSeller] = useState(null);
  const [loading, setLoading] = useState(true);
  const [storeLoading, setStoreLoading] = useState(false);

  useEffect(() => {
    fetchSellerProfile();
  }, []);

  const fetchSellerProfile = async () => {
    try {
      const response = await sellerService.getProfile();
      setSeller(response.data.seller);
    } catch (error) {
      toast.error('Failed to load profile');
    } finally {
      setLoading(false);
    }
  };

  const handleProfileSubmit = async (data) => {
    await updateProfile(data);
  };

  const handleStoreSubmit = async (data) => {
    setStoreLoading(true);
    try {
      await sellerService.updateProfile(data);
      toast.success('Store settings updated');
      fetchSellerProfile();
    } catch (error) {
      toast.error('Failed to update store settings');
    } finally {
      setStoreLoading(false);
    }
  };

  if (loading) return <LoadingSpinner fullScreen />;

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ 
          fontSize: theme.typography.fontSize['3xl'], 
          fontWeight: theme.typography.fontWeight.bold, 
          marginBottom: theme.spacing.xl 
        }}>
          Profile & Store Settings
        </h1>
        
        <div style={{ marginBottom: theme.spacing.xl }}>
          <ProfileForm user={user} onSubmit={handleProfileSubmit} loading={profileLoading} />
        </div>

        <StoreSettingsForm seller={seller} onSubmit={handleStoreSubmit} loading={storeLoading} />
      </div>
    </MainLayout>
  );
};

export default SellerProfile;